module.exports = __webpack_public_path__ + "static/media/enter-project-name.840052f7.png";